import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { FIXED_INDENTS, MEDIA } from 'vars/index'

export const GeoblockUnavailableSC = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  gap: var(${FIXED_INDENTS.INDENT_20});
  padding: 0 var(${FIXED_INDENTS.INDENT_40});

  ${MEDIA.MIN_600} {
    gap: var(${FIXED_INDENTS.INDENT_30});
  }

  ${TextBoxSC} {
    max-width: 480px;
  }
`
